export default "__VITE_ASSET__DlgVujtr__"